import { ROUTER_LINKS_FULL_PATH, ROUTER_LINKS } from './routing.config';

enum SUBMODULES_LEVEL {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
}

export const MODULE_ID = {
  'dashboard': 3001,
  'poDashboard': 4301,
  'users': 1101,
  'profile': 1102,
  'freelancers': 1103,
  'vendors': 1104,
  'talent': 1201,
  'individual': 1202,
  'agency': 1203,
  'projects': 1301,
  'pal': 1302,
  'budget': 1303,
  'budgetDetails': 1304,
  'purchaseOrder': 1305,
  'freelancerPO': 1306,
  'vendorPO': 1307,
  'locationPO': 1308,
  'advancePO': 1309,
  'talentPO': 1310,
  'settlement': 1311,
  'paymentOrder': 1312,
  'budgetSettings': 1313,
  'budgetSettingsConfiguration': 1314,
  'budgetSettingsPaymentTerms': 1315,
  'budgetSettingsApprovalHierarchy': 1316,
  'budgetSettingsCurrencies': 1317,
  'masterPurchaseOrder': 1318,
  'masterPaymentOrders': 1319,
  'masterSettlement': 1411,
  'viewBudget': 1320,
  'addWorking': 1321,
  'projectBudgetPayments': 1322,
  'payments': 1401,
  'locations': 1501,
  'category': 1502,
  'locationList': 1503,
  'review': 1504,
  'scouterAccess': 1505,
  'bidding': 1601,
  'leads': 1602,
  'bids': 1603,
  'dealMasterConfiguration': 1604,
  'dealApprovalHierarchy': 1605,
  'projectMasterConfiguration': 1606,
  'projectApprovalHierarchy': 1607,
  'bidBasicInfo': 1603,
  'bidBusinessTerms': 1603,
  'bidCrew': 1603,
  'bidProductionParameters': 1603,
  'bidTalent': 1603,
  'bidEditingAndPost': 1603,
  'bidAicp': 1603,
  'bidPasses': 1603,
  'roles': 1701,
  'presentation': 1018,
  'commercial': 1202,
  'corporate': 1006,
  'entertainment': 1007,
  'settings': 1008,
  'annualContract': 1009,
  'clients': 1019,
  'employee': 4101,
  'projectDetails': 1051,
  'invoice': 1054,
  'configuration': 1056,
  'paymentTerms': 1057,
  'approvalHeirarchy': 1058,
  'currencies': 1059,

  'hospitality': 1801,
  'hospitalityExpenses': 1901,
  'hospitalityReport': 2000,
  'reportProfiles': 2101,
  'reportFeedback': 2201,
  'reportImprovements': 2301,
  'reportActivities': 2001,
  'casting': 3103,
  'prep': 3901,
  'dailySchedule': 3501,
  'directorScout': 3601,
  'travelMovement': 3801,
  'callSheet': 3701,
  'clientMaster': 4001,
  'exportInvoices': 1323,
  'exportSettlement': 1412,
  'exportPayments': 1423,
  'export': 1400
};

const Dashboard = {
  'text': 'dashboard',
  'link': ROUTER_LINKS_FULL_PATH.dashboard,
  'icon': 'icon-speedometer',
  'moduleId': MODULE_ID.dashboard,
  'canLandingPage': true
};

const PODashboard = {
  'text': 'poDashboard',
  'link': ROUTER_LINKS_FULL_PATH.poDashboard,
  'icon': 'icon-speedometer',
  'moduleId': MODULE_ID.poDashboard,
  'canLandingPage': true
};

const Profile = {
  'text': 'profile',
  'link': ROUTER_LINKS_FULL_PATH.profile,
  'icon': 'icon-user',
  'moduleId': MODULE_ID.profile,
  'canLandingPage': true
};

// const Annual_Contract = {
//   'text': 'annualContract',
//   'link': ROUTER_LINKS_FULL_PATH.annualContract,
//   'icon': 'fa fa-folder-open',
//   'moduleId': MODULE_ID.annualContract
// };

/**
 * Start Sub Modules of Project modules
 */
const PAL = {
  'text': 'pal',
  'moduleId': MODULE_ID.pal,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': false
};

const Budget = {
  'text': 'budget',
  'moduleId': MODULE_ID.budget,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': false
};


const Hospitality = {
  'text': 'hospitality',
  'moduleId': MODULE_ID.hospitality,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': false
};
const HospitalityExpenses = {
  'text': 'hospitalityExpenses',
  'moduleId': MODULE_ID.hospitalityExpenses,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': false
};
const HospitalityReport = {
  'text': 'hospitalityReport',
  'moduleId': MODULE_ID.hospitalityReport,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': false
};
const PREP = {
  'text': 'prep',
  'moduleId': MODULE_ID.prep,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': false
};

const PREP_DAILY_SCHEDULE = {
  'text': 'dailySchedule',
  'moduleId': MODULE_ID.dailySchedule,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};

const PREP_DIRECTOR_SCOUT = {
  'text': 'directorScout',
  'moduleId': MODULE_ID.directorScout,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};

const PREP_TRAVEL_MOVEMENT = {
  'text': 'travelMovement',
  'moduleId': MODULE_ID.travelMovement,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};

const PREP_CALL_SHEET = {
  'text': 'callSheet',
  'moduleId': MODULE_ID.callSheet,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};


const ReportActivities = {
  'text': 'reportActivities',
  'moduleId': MODULE_ID.reportActivities,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};
const ReportProfiles = {
  'text': 'reportProfiles',
  'moduleId': MODULE_ID.reportProfiles,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};
const ReportFeedback = {
  'text': 'reportFeedback',
  'moduleId': MODULE_ID.reportFeedback,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};
const ReportImprovements = {
  'text': 'reportImprovements',
  'moduleId': MODULE_ID.reportImprovements,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};

const AddWorking = {
  'text': 'addWorking',
  'moduleId': MODULE_ID.addWorking,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};

const ViewBudget = {
  'text': 'viewBudget',
  'moduleId': MODULE_ID.viewBudget,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};

/**
 * Start Sub Modules of Budget Details
 */



const FreelancerPO = {
  'text': 'freelancerPO',
  'moduleId': MODULE_ID.freelancerPO,
  'subModuleLevel': SUBMODULES_LEVEL.FOUR,
  'canLandingPage': false
};

const VendorPO = {
  'text': 'vendorPO',
  'moduleId': MODULE_ID.vendorPO,
  'subModuleLevel': SUBMODULES_LEVEL.FOUR,
  'canLandingPage': false
};

const LocationPO = {
  'text': 'locationPO',
  'moduleId': MODULE_ID.locationPO,
  'subModuleLevel': SUBMODULES_LEVEL.FOUR,
  'canLandingPage': false
};

const AdvancePO = {
  'text': 'advancePO',
  'moduleId': MODULE_ID.advancePO,
  'subModuleLevel': SUBMODULES_LEVEL.FOUR,
  'canLandingPage': false
};

const TalentPO = {
  'text': 'talentPO',
  'moduleId': MODULE_ID.talentPO,
  'subModuleLevel': SUBMODULES_LEVEL.FOUR,
  'canLandingPage': false
};

const PurchaseOrder = {
  'text': 'purchaseOrder',
  'moduleId': MODULE_ID.purchaseOrder,
  'subModuleLevel': SUBMODULES_LEVEL.THREE,
  'canLandingPage': false
};

const Settlement = {
  'text': 'settlement',
  'moduleId': MODULE_ID.settlement,
  'subModuleLevel': SUBMODULES_LEVEL.THREE,
  'canLandingPage': false
};

const PaymentOrder = {
  'text': 'paymentOrder',
  'moduleId': MODULE_ID.paymentOrder,
  'subModuleLevel': SUBMODULES_LEVEL.THREE,
  'canLandingPage': false
};

const ProjectBudgetPayment = {
  'text': 'payments',
  'moduleId': MODULE_ID.projectBudgetPayments,
  'subModuleLevel': SUBMODULES_LEVEL.THREE,
  'canLandingPage': false
};

/**
 * End Sub Modules of Budget Details Module
 */

const BudgetDetails = {
  'text': 'budgetDetails',
  'moduleId': MODULE_ID.budgetDetails,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};


/**
 * Start Sub Modules of Budget Details
 */
const BudgetSettingsConfiguration = {
  'text': 'configuration',
  'moduleId': MODULE_ID.budgetSettingsConfiguration,
  'subModuleLevel': SUBMODULES_LEVEL.THREE,
  'canLandingPage': false
};

const BudgetSettingsPaymentTerms = {
  'text': 'paymentTerms',
  'moduleId': MODULE_ID.budgetSettingsPaymentTerms,
  'subModuleLevel': SUBMODULES_LEVEL.THREE,
  'canLandingPage': false
};

const BudgetSettingsApprovalHierarchy = {
  'text': 'approvalHierarchy',
  'moduleId': MODULE_ID.budgetSettingsApprovalHierarchy,
  'subModuleLevel': SUBMODULES_LEVEL.THREE,
  'canLandingPage': false
};

const BudgetSettingsCurrencies = {
  'text': 'currencies',
  'moduleId': MODULE_ID.budgetSettingsCurrencies,
  'subModuleLevel': SUBMODULES_LEVEL.THREE,
  'canLandingPage': false
};

/**
 * End Sub Modules of Budget Settings
 */


const BudgetSettings = {
  'text': 'budgetSettings',
  'moduleId': MODULE_ID.budgetSettings,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};

/**
 * End Sub Modules of Project module
 */

const Projects = {
  'text': 'projects',
  'link': ROUTER_LINKS_FULL_PATH.projects,
  'icon': 'icon-badge',
  'moduleId': MODULE_ID.projects,
  'canLandingPage': true
};

/**
 * Start Sub Modules of Users Module
 */
const Freelancers = {
  'text': 'freelancers',
  'link': ROUTER_LINKS_FULL_PATH.freelancers,
  // 'icon': 'icon-user',
  'moduleId': MODULE_ID.freelancers,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': true
};

const Vendors = {
  'text': 'vendors',
  'link': ROUTER_LINKS_FULL_PATH.vendors,
  // 'icon': 'fa fa-institution',
  'moduleId': MODULE_ID.vendors,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': true
};

/**
 * End Sub Modules of Users Module
 */

const Users = {
  'text': 'users',
  'link': ROUTER_LINKS_FULL_PATH.users,
  'icon': 'icon-user',
  'moduleId': MODULE_ID.users,
  'submenu': [Freelancers, Vendors],
  'canLandingPage': false
};

const Agency = {
  'text': 'agency',
  'link': ROUTER_LINKS_FULL_PATH.agency,
  // 'icon': 'icon-user',
  'moduleId': MODULE_ID.agency,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': true
};

const Individual = {
  'text': 'individual',
  'link': ROUTER_LINKS_FULL_PATH.individual,
  // 'icon': 'icon-user',
  'moduleId': MODULE_ID.individual,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': true
};

const Talent = {
  'text': 'talent',
  'link': ROUTER_LINKS_FULL_PATH.talent,
  'icon': 'icon-user',
  'moduleId': MODULE_ID.talent,
  'submenu': [Agency, Individual],
  'canLandingPage': false
};

// const Commercial = {
//   'text': 'commercial',
//   'link': ROUTER_LINKS_FULL_PATH.commercial,
//   // 'icon': 'icon-user',
//   'moduleId': MODULE_ID.commercial
// };

// const Corporate = {
//   'text': 'corporate',
//   'link': ROUTER_LINKS_FULL_PATH.corporate,
//   // 'icon': 'icon-user',
//   'moduleId': MODULE_ID.corporate
// };

// const Entertainment = {
//   'text': 'entertainment',
//   'link': ROUTER_LINKS_FULL_PATH.entertainment,
//   // 'icon': 'icon-user',
//   'moduleId': MODULE_ID.entertainment
// };

// const Settings = {
//   'text': 'settings',
//   'link': ROUTER_LINKS_FULL_PATH.settings,
//   'icon': 'fa fa-cogs',
//   'moduleId': MODULE_ID.settings,
//   'submenu': [Corporate, Commercial, Entertainment]
// };

// const Brands = {
//   'text': 'brands',
//   'link': ROUTER_LINKS_FULL_PATH.brands,
//   // 'icon': 'icon-location-pin',
//   'moduleId': MODULE_ID.brands
// };
// const Agencies = {
//   'text': 'agencies',
//   'link': ROUTER_LINKS_FULL_PATH.agencies,
//   // 'icon': 'icon-user',
//   'moduleId': MODULE_ID.agencies
// };
// const Production_Companies = {
//   'text': 'productionCompanies',
//   'link': ROUTER_LINKS_FULL_PATH.productionCompanies,
//   // 'icon': 'icon-user',
//   'moduleId': MODULE_ID.productionCompanies
// };

// const Clients = {
//   'text': 'clients',
//   'link': ROUTER_LINKS_FULL_PATH.entertainment,
//   'icon': 'icon-people',
//   'moduleId': MODULE_ID.entertainment,
//   'submenu': [Brands, Agencies, Production_Companies]
// };

/**
 * Sub Menu of Locations
 */
const LocationList = {
  'text': 'locationList',
  'link': ROUTER_LINKS_FULL_PATH.locationsView,
  'moduleId': MODULE_ID.locationList,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': true
};

/**
 * Sub Menu of Locations
 */
const Review = {
  'text': 'review',
  'link': ROUTER_LINKS_FULL_PATH.review,
  'moduleId': MODULE_ID.review,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': true
};

/**
 * Sub Menu of Locations
 */
// const Presentation = {
//   'text': 'presentation',
//   'link': ROUTER_LINKS_FULL_PATH.presentation,
//   'moduleId': MODULE_ID.presentation
// };

/**
 * Sub Menu of Locations
 */
const CategoryList = {
  'text': 'categoryList',
  'link': ROUTER_LINKS_FULL_PATH.category,
  'moduleId': MODULE_ID.category,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': true
};

/**
 * Sub Menu of Locations
 */
const ScouterAccess = {
  'text': 'scouterAccess',
  'link': ROUTER_LINKS_FULL_PATH.scouters,
  'moduleId': MODULE_ID.scouterAccess,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': true
};

/**
 * Main Menu of Locations
 */
const Locations = {
  'text': 'locations',
  'link': ROUTER_LINKS_FULL_PATH.locations,
  'icon': 'icon-location-pin',
  'moduleId': MODULE_ID.locations,
  'submenu': [CategoryList, LocationList, Review, ScouterAccess],
  'canLandingPage': false
};

/**
 * Main Menu of Master Purchase Orders
 */
const MasterPurchaseOrder = {
  'text': 'po',
  'link': ROUTER_LINKS_FULL_PATH.masterPO,
  'icon': 'fa fa-book',
  'moduleId': MODULE_ID.masterPurchaseOrder,
  'canLandingPage': true
};

/**
 * Main Menu of Master Payment Orders
 */
const MasterInvoice = {
  'text': 'paymentOrder',
  'link': ROUTER_LINKS_FULL_PATH.masterPaymentOrder,
  'icon': 'fa fa-clipboard',
  'moduleId': MODULE_ID.masterPaymentOrders,
  'canLandingPage': true
};

/**
 * Main Menu of Payments
 */
const Payments = {
  'text': 'payments',
  'link': ROUTER_LINKS_FULL_PATH.payments,
  'icon': 'fa fa-usd',
  'moduleId': MODULE_ID.payments,
  'canLandingPage': true
};

/**
 * Sub Menu of Lead List
 */
const LeadList = {
  'text': 'leadList',
  'link': ROUTER_LINKS_FULL_PATH.leads,
  // 'icon': 'icon-user',
  'moduleId': MODULE_ID.leads,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': true
};



/**
 * Start Sub modules of Bid  module
 */


const DealMasterConfiguration = {
  'text': 'dealMasterConfiguration',
  'moduleId': MODULE_ID.dealMasterConfiguration,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};

const DealApprovalHierarchy = {
  'text': 'dealApprovalHierarchy',
  'moduleId': MODULE_ID.dealApprovalHierarchy,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};
const ProjectMasterConfiguration = {
  'text': 'projectMasterConfiguration',
  'moduleId': MODULE_ID.projectMasterConfiguration,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};

const ProjectApprovalHierarchy = {
  'text': 'projectApprovalHierarchy',
  'moduleId': MODULE_ID.projectApprovalHierarchy,
  'subModuleLevel': SUBMODULES_LEVEL.TWO,
  'canLandingPage': false
};
/**
 * End Sub modules of Bid  module
 */


/**
 * Sub Menu of Bid List
 */
const BidList = {
  'text': 'bidList',
  'link': ROUTER_LINKS_FULL_PATH.bids,
  // 'icon': 'fa fa-institution',
  'moduleId': MODULE_ID.bids,
  'subModuleLevel': SUBMODULES_LEVEL.ONE,
  'canLandingPage': true
};

/**
 * Main Menu of Bidding
 */
const Bidding = {
  'text': 'bidding',
  'link': ROUTER_LINKS_FULL_PATH.bidding,
  'icon': 'fa fa-gavel',
  'moduleId': MODULE_ID.bidding,
  'submenu': [LeadList, BidList],
  'canLandingPage': false
};

const Roles = {
  'text': 'roles',
  'link': ROUTER_LINKS_FULL_PATH.roles,
  'icon': 'icon-key',
  'moduleId': MODULE_ID.roles,
  'canLandingPage': true
};

const Employees = {
  'text': 'employees',
  'link': ROUTER_LINKS_FULL_PATH.employees,
  'icon': 'icon-key',
  'moduleId': MODULE_ID.employee,
  'canLandingPage': true
};

const Casting = {
  'text': 'casting',
  'link': ROUTER_LINKS_FULL_PATH.casting,
  'icon': 'icon-user',
  'moduleId': MODULE_ID.casting
};

/**
 * Main Menu of Payments
 */
const ClientMaster = {
  'text': 'clientMaster',
  'link': ROUTER_LINKS_FULL_PATH.clientMaster,
  'icon': 'icon-user',
  'moduleId': MODULE_ID.clientMaster,
  'canLandingPage': true
};

const ExportInvoices = {
  'text': 'exportInvoices',
  'link': ROUTER_LINKS_FULL_PATH.exportInvoices,
  'icon': '',
  'moduleId': MODULE_ID.exportInvoices,
  'canLandingPage': true,
  'subModuleLevel': SUBMODULES_LEVEL.ONE
};

const ExportSettlement = {
  'text': 'settlement',
  'link': ROUTER_LINKS_FULL_PATH.exportSettlement,
  'icon': '',
  'moduleId': MODULE_ID.exportSettlement,
  'canLandingPage': true,
  'subModuleLevel': SUBMODULES_LEVEL.ONE
};

const ExportPayments = {
  'text': 'payments',
  'link': ROUTER_LINKS_FULL_PATH.exportPayments,
  'icon': '',
  'moduleId': MODULE_ID.exportPayments,
  'canLandingPage': true,
  'subModuleLevel': SUBMODULES_LEVEL.ONE
};

const Export = {
  'text': 'export',
  'link': ROUTER_LINKS_FULL_PATH.export,
  'icon': 'fa fa-floppy-o',
  'moduleId': MODULE_ID.export,
  'submenu': [ExportInvoices, ExportSettlement, ExportPayments],
  'canLandingPage': false
};

const MasterSettlement = {
  'text': 'masterSettlement',
  'link': ROUTER_LINKS_FULL_PATH.masterSettlement,
  'icon': 'fa fa-handshake-o',
  'moduleId': MODULE_ID.masterSettlement,
  'canLandingPage': true
};

export const MENU_CONFIG = [
  Dashboard,
  PODashboard,
  Profile,
  Users,
  Talent,
  Projects,
  MasterPurchaseOrder,
  MasterInvoice,
  Payments,
  MasterSettlement,
  // Settings,
  Export,
  Roles,
  Employees,
];

export const ARCHIVE_MENU_CONFIG = [
  Projects,
  MasterPurchaseOrder,
  MasterInvoice,
  Payments,
  MasterSettlement,
  Export,
];


export const MENU_CONFIG_ALL_MENUS = [
  Dashboard,
  PODashboard,
  // Bidding,
  // LeadList,
  // BidList,
  // DealMasterConfiguration,
  // DealApprovalHierarchy,
  // ProjectMasterConfiguration,
  // ProjectApprovalHierarchy,
  Profile,
  Users,
  Freelancers,
  Vendors,
  Talent,
  Agency,
  Individual,
  // Casting,
  Projects,
  PAL,
  Budget,
  ViewBudget,
  AddWorking,
  BudgetDetails,
  PurchaseOrder,
  AdvancePO,
  FreelancerPO,
  LocationPO,
  TalentPO,
  VendorPO,
  Settlement,
  PaymentOrder,
  ProjectBudgetPayment,
  BudgetSettings,
  BudgetSettingsConfiguration,
  BudgetSettingsPaymentTerms,
  BudgetSettingsApprovalHierarchy,
  BudgetSettingsCurrencies,
  // Hospitality,
  // HospitalityExpenses,
  // HospitalityReport,
  // ReportActivities,
  // ReportProfiles,
  // ReportFeedback,
  // ReportImprovements,
  // PREP,
  // PREP_DAILY_SCHEDULE,
  // PREP_DIRECTOR_SCOUT,
  // PREP_TRAVEL_MOVEMENT,
  // PREP_CALL_SHEET,
  MasterPurchaseOrder,
  MasterInvoice,
  Payments,
  MasterSettlement,
  // ClientMaster,
  // Locations,
  // CategoryList,
  // LocationList,
  // Review,
  // ScouterAccess,
  Export,
  ExportSettlement,
  ExportInvoices,
  ExportPayments,
  Roles,
  Employees,

];



// WEBPACK FOOTER //
// ./src/app/config/menu.config.ts